import * as React from 'react'
import styled from 'styled-components'

import { BaseAddress } from '@owl-nest/api-client/latest'
import * as shadow from '@owl-nest/shadow'
import { Country } from '@owl-nest/config'

import { AddressSubForm } from './AddressSubForm'
import { AutoCompleteControl } from './AutoCompleteControl'

type AutocompleteSubFormProps = {
  className?: string
  disabled?: boolean
  hideAutocompleteControl?: boolean
  hideCountry?: boolean
  label?: string
  language: string
  countryFilter?: string[]
  disableCountry?: boolean
  errors: { [K in keyof BaseAddress]?: string }
  touched: { [K in keyof BaseAddress]?: boolean }
  hideState?: boolean
  countries: Country[]
  address: BaseAddress
  initialEmpty: boolean
  context?: string
  placeholder?: string
  onChange: (
    address: BaseAddress & {
      latitude?: number
      longitude?: number
    },
  ) => void
  searchInputRef?: React.RefObject<HTMLInputElement>
}

export function AutocompleteSubFormComponent({
  hideCountry = false,
  disabled = false,
  hideAutocompleteControl = false,
  label,
  language,
  countryFilter,
  countries,
  onChange,
  address,
  errors,
  touched,
  className,
  hideState = false,
  disableCountry,
  context,
  placeholder,
  initialEmpty,
  searchInputRef,
}: AutocompleteSubFormProps): React.ReactElement<AutocompleteSubFormProps> {
  const [isEmpty, setIsEmpty] = React.useState(initialEmpty)

  const addressSelectTrack = shadow.plausible.useAddressSelectTracking()

  return (
    <>
      <AutoCompleteControl
        hidden={hideAutocompleteControl}
        label={label}
        searchInputRef={searchInputRef}
        countries={countries}
        language={language}
        context={context}
        countryFilter={countryFilter}
        placeholder={placeholder}
        onSelect={(address) => {
          handleChange(address)
          addressSelectTrack({
            interaction: 'Autocomplete',
          })
        }}
        onManual={(address) => {
          handleChange(address)
          addressSelectTrack({
            interaction: 'Manual',
          })
        }}
        className={className}
      />
      {!isEmpty && address !== undefined && (
        <AddressSubForm
          disabled={disabled}
          errors={errors}
          hideState={hideState}
          hideCountry={hideCountry}
          touched={touched}
          value={address}
          onChange={onChange}
          countryFilter={countryFilter}
          countries={countries}
          disableCountry={disableCountry}
        />
      )}
    </>
  )

  function handleChange(
    address: BaseAddress & {
      latitude?: number
      longitude?: number
    },
  ): void {
    const country = countries.find((country) => country.code === address.country.toUpperCase())
    setIsEmpty(false)
    onChange({
      ...address,
      country: country ? country.code : address.country,
    })
  }
}

export const AutocompleteSubForm = styled(AutocompleteSubFormComponent)``
